export {default as dispatch} from "./dispatch.js";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-dispatch/src/index.js
// module id = 33
// module chunks = 0